import deliverySetCompleteApi from '@/api/delivery/delivery-set-complete-api';

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async init() {
      try {
        const response = await deliverySetCompleteApi.init();
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async printCredits({dispatch}, form) {
      try {
        const response = await deliverySetCompleteApi.printCredits(form);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
